import { useRequest } from 'features/request/useRequest';
import { ExportCSVReport } from 'utils/createCSVReportFile';

import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { importActKC2TemplateAsExcelGql } from '../importActKC2TemplateQueries';

export const useActKC2TemplateUpload = (workOrderId: number, setFiles: (files: File[]) => any) => {
    const dispatch = useDispatch();
    const [isSubmitted, setIsSubmitted] = useState(false);

    const [
        importActKC2TemplateAsExcelData,
        importActKC2TemplateAsExcelStatus,
        importActKC2TemplateAsExcelError,
        importActKC2TemplateAsExcelMakeRequest,
        importActKC2TemplateAsExcelSetData,
    ] = useRequest({
        requestId: 'importActKC2TemplateAsExcel',
        query: importActKC2TemplateAsExcelGql,
        withEffect: false,
    });

    const resetData = useCallback(() => {
        dispatch(importActKC2TemplateAsExcelSetData(undefined));
        setIsSubmitted(false);
        setFiles([]);
    }, [dispatch, importActKC2TemplateAsExcelSetData, setFiles]);

    const makeRequest = useCallback(
        (actKC2Template) => {
            if (actKC2Template) {
                dispatch(importActKC2TemplateAsExcelMakeRequest({ workOrderId, actKC2Template }));
                setIsSubmitted(true);
            }
        },
        [dispatch, importActKC2TemplateAsExcelMakeRequest, workOrderId],
    );

    const onCloseModalError = useCallback(() => {
        resetData();
    }, [resetData]);

    const onCreateReport = useCallback(() => {
        ExportCSVReport(importActKC2TemplateAsExcelData?.uerImportActKC2TemplateAsExcel?.validation);
    }, [importActKC2TemplateAsExcelData?.uerImportActKC2TemplateAsExcel?.validation]);

    return {
        importActKC2TemplateAsExcelData,
        importActKC2TemplateAsExcelStatus,
        importActKC2TemplateAsExcelError,
        makeRequest,
        onCloseModalError,
        onCreateReport,
        isSubmitted,
        resetData,
    };
};
